class GridDebugLayer extends L.GridLayer {
  createTile(coords: L.Coords) {
    const tile = document.createElement('div');
    tile.style.outline = '1px solid green';
    tile.style.fontWeight = 'bold';
    tile.style.fontSize = '14pt';
    tile.innerHTML = [coords.z, coords.x, coords.y].join('/');
    return tile;
  }
};

const gridDebugLayer = function (opts: L.GridLayerOptions) {
  return new GridDebugLayer(opts);
};

export { gridDebugLayer, GridDebugLayer };